import {
    KRIReviewDto,
    PanelDto,
    SiteScoreDto,
    StudyDashboardPanelData,
    StudyPanelData,
} from '@interfaces/central-monitoring';
import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import { getData, postData } from '@apis/rest-client';

const endpoints = {
    getKRIReview: (studyRef: string, datasetId: number, panelRef: string) =>
        `CentralMonitoring/KriReview/${studyRef}/${datasetId}/${panelRef}`,
};

const KriOverviewApi = {
    useGet: (studyRef: string, panelRef?: string, datasetId?: number) => {
        const url =
            datasetId && panelRef
                ? `CentralMonitoring/Panels/${studyRef}/study-panel-data/${datasetId}/${panelRef}`
                : null;

        return useSWR<StudyPanelData>(url, getData);
    },

    useGetPanels: (studyRef: string, datasetId?: number) => {
        const url = `CentralMonitoring/Panel/${studyRef}/${datasetId}`;

        return useSWR<PanelDto[]>(datasetId ? url : null, getData);
    },

    useGetPanelData: (studyRef: string, datasetId?: number, panelRef?: string) => {
        const url = datasetId && panelRef ? `CentralMonitoring/Panel/data/${studyRef}/${datasetId}/${panelRef}` : null;

        return useSWR<StudyDashboardPanelData>(url, getData);
    },

    useGetPanelSiteScores: (studyRef: string, datasetId?: number, panelRef?: string) => {
        const url =
            datasetId && panelRef
                ? `CentralMonitoring/Panel/data/site-scores/${studyRef}/${datasetId}/${panelRef}`
                : null;

        return useSWR<SiteScoreDto[]>(url, getData);
    },

    useGetKRIReview: (studyRef: string, datasetId?: number, panelRef?: string) => {
        const url = datasetId && panelRef ? endpoints.getKRIReview(studyRef, datasetId, panelRef) : null;

        return useSWR<KRIReviewDto>(url, getData);
    },
    invalidateGetKRIReview: (studyRef: string, datasetId: number, panelRef: string) => {
        return mutate(endpoints.getKRIReview(studyRef, datasetId, panelRef));
    },

    useSave: (studyRef: string, datasetId?: number, panelRef?: string) => {
        const saveUrl = `CentralMonitoring/KriReview/${studyRef}/${datasetId}/${panelRef}`;

        return useSWRMutation(saveUrl, (url: string, { arg }: { arg: KRIReviewDto }) => {
            return postData<KRIReviewDto, KRIReviewDto>(url, { arg, timeout: 30000 });
        });
    },
};

export default KriOverviewApi;
